import { UpdateTripTransportInput } from '@allocab/allocab-commons-shared-types';
import { TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { mutationKeys } from '../services/datastore/mutationKeys';
import { queryKeys } from '../services/datastore/queryKeys';
import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

const updateAnonymousTransport = (input: UpdateTripTransportInput, key: string, jwtToken?: string) =>
  passengerApi.patch<UpdateTripTransportInput, TripOutput>(`/anonymous/v1/${key}/update-transport`, input, {
    headers: { Authorization: `Bearer ${jwtToken}` },
  });

export const useUpdateAnonymousTransport = (key: string, jwToken?: string) => {
  const queryClient = useQueryClient();
  const updateAnonymousTransportMutation = useMutation<TripOutput, APIError, UpdateTripTransportInput>({
    mutationKey: mutationKeys.user.updateTransport(key),
    mutationFn: input => updateAnonymousTransport(input, key, jwToken),
    onSuccess: trip => {
      queryClient.setQueryData(queryKeys.fetchAnonymousTrip(jwToken), trip);
    },
  });

  return updateAnonymousTransportMutation;
};
